import { css } from '@emotion/react';
import { theme } from 'global';

export const dialog = css`
  .MuiDialog-paper {
    width: min(520px, calc(100vw - 24px));
    max-width: 520px;
    border-radius: 16px;
    overflow: hidden;
  }

  .MuiDialogContent-root {
    padding: 0 !important;
  }

  .MuiDialogActions-root {
    align-items: center;
    background-color: ${theme.colors.white};
    border-top: 1px solid ${theme.colors.neutral[100]};
    display: flex;
    justify-content: flex-end;
    padding: 12px 16px;
  }

  @media screen and (max-width: ${theme.breaks.xs}px) {
    &.MuiDialog-root {
      .MuiDialog-container {
        align-items: center;
        justify-content: center;
      }

      .MuiDialog-paper {
        margin: 16px;
        max-width: calc(100vw - 24px);
        position: relative;
        transform: none;
      }
    }

    &.MuiDialog-root .MuiDialog-scrollBody {
      align-items: center;
      justify-content: center;
    }
  }
`;

export const dialogContent = css`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 32px 24px 24px;
`;

export const title = css`
  color: ${theme.colors.secondary};
  margin: 0;
  font-size: 26px;
`;

export const sections = css`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
`;

export const section = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const sectionContent = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const sectionTitle = css`
  color: ${theme.colors.neutral[600]};
  margin: 0;
`;

export const bodyCopy = css`
  color: ${theme.colors.neutral[600]};
  margin: 0;
`;

export const chartPanel = css`
  background-color: ${theme.colors.neutral[50]};
  box-sizing: border-box;
  height: 265px;
  overflow: hidden;
  position: relative;
  width: 100%;

  @media screen and (max-width: ${theme.breaks.xs}px) {
    margin-left: -24px;
    margin-right: -24px;
    width: calc(100% + 48px);
  }
`;

export const chartBubble = css`
  align-items: center;
  background-color: ${theme.colors.primary.lightest};
  border: 1px solid ${theme.colors.primary.medium};
  border-radius: 40px;
  box-sizing: border-box;
  display: flex;
  height: 30px;
  justify-content: center;
  left: 50%;
  padding: 0 14px;
  position: absolute;
  top: 57px;
  transform: translateX(-50%);
  width: 271px;
  z-index: 2;
`;

export const chartBubbleText = css`
  color: ${theme.colors.primary.medium};
  white-space: nowrap;
  margin: 0;

  span {
    font-size: 13px;
  }
`;

export const chartCanvas = css`
  inset: 0;
  position: absolute;
  width: 100%;
`;

export const chartGuideLine = css`
  border-top: 1px dashed ${theme.colors.primary.medium};
  left: 50%;
  position: absolute;
  top: 116px;
  transform: translateX(-50%);
  width: 310px;
`;

export const chartConnector = css`
  border-left: 1px solid ${theme.colors.primary.medium};
  height: 29.5px;
  left: 50%;
  position: absolute;
  top: 86px;
`;

export const chartConnectorDot = css`
  background-color: ${theme.colors.primary.medium};
  border-radius: 50%;
  height: 6px;
  left: calc(50% - 3px);
  position: absolute;
  top: 113px;
  width: 6px;
`;

export const chartBaseline = css`
  border-top: 1px solid ${theme.colors.neutral[300]};
  left: 50%;
  position: absolute;
  top: 196px;
  transform: translateX(-50%);
  width: 313px;
`;

export const chartColumns = css`
  align-items: flex-start;
  display: flex;
  gap: 55px;
  left: 50%;
  position: absolute;
  top: 116px;
  transform: translateX(-50%);
`;

export const chartColumn = css`
  align-items: center;
  display: flex;
  flex-direction: column;
  min-width: 88px;
  width: 88px;
`;

export const fixedBar = css`
  background-color: ${theme.colors.primary.medium};
  height: 80px;
  width: 88px;
`;

export const percentageBar = css`
  background-color: ${theme.colors.primary.medium};
  height: 18px;
  margin-top: 62px;
  width: 88px;
`;

export const chartLabel = css`
  color: ${theme.colors.neutral[600]};
  margin: 8px 0 0 0;
  text-align: center;
  white-space: nowrap;
`;

export const chartSubLabel = css`
  color: ${theme.colors.neutral[600]};
  margin: 0;
  text-align: center;
  white-space: nowrap;
`;
